import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faEye,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  Card,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "@themesberg/react-bootstrap";

import {
  GetAllSurvey,
  reset,
} from "../../../features/SurveySlice";
import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import axios from "axios";
import BASE_URL from "../../../api";
import PaginationComponent from "../../../components/admin/PaginationComponent";
import moment from "moment";

const DataList = () => {
  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [sortType, setSortType] = useState("DESC");
  const [row, setRow] = useState("10");
  const [page, setPage] = useState("1");

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.survey);

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchDataListMasterSurvey();
  }, [dispatch, token, page, sortBy, sortType, row]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchDataListMasterSurvey();
  };

  const fetchDataListMasterSurvey = () => {
    dispatch(reset());
    dispatch(
      GetAllSurvey({
        token,
        url: `q=${query}&pageNumber=${page}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
      })
    );
  };

  const handlePagination = (item) => {
    setPage(item);
  };

  const onClickDelete = (id) => {
    showAlertDialog({
      title: "Hapus?",
      msg: "Apakah anda yakin ingin menghapus ini?",
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.delete(
              `${BASE_URL}master/survey/${id}`,
              {
                headers: {
                  Authorization: token,
                },
              }
            );
            console.log("RESPONSE : ", response);
            hideLoadingDialog();
            showSuccessDialog({
              title: "Berhasil!",
              msg: "Berhasil menghapus data!",
            });
            fetchDataListMasterSurvey();
          } else {
            throw "id not found!";
          }
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menghapus data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      <Header>
        <Button
          variant="outline-primary"
          size="sm"
          href={`/master/survey/add`}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Tambah
        </Button>
      </Header>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between">
              <form onSubmit={handleSearch}>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </InputGroup>
              </form>
              <div className="d-flex gap-3">
                <Form.Group>
                  <Form.Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    <option value="created_at">Dibuat</option>
                    <option value="nama">Nama</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    value={sortType}
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    <option value="DESC">DESC</option>
                    <option value="ASC">ASC</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table
            responsive
            striped
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                <th className="border-0">Nama</th>
                <th className="border-0">Deskripsi</th>
                <th className="border-0">Active</th>
                <th className="border-0">Tanggal Dibuat</th>
                <th className="border-0 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <th colSpan="6" style={{ textAlign: "center" }}>
                    Loading...
                  </th>
                </tr>
              ) : (data?.items || []).length > 0 ? (
                data?.items?.map((item, i) => (
                  <tr key={item.id}>
                    <th>{((page-1)*10) + (i + 1)}</th>
                    <th>{item.nama}</th>
                    <th>{item.deskripsi}</th>
                    <th>{item.active ? "AKTIF" : "NONAKTIF"}</th>
                    <th>{moment(item.created_at).format("DD MMM YYYY")}</th>
                    <th className="text-center">
                      <ButtonGroup size="sm">
                        <Button
                          as={Link}
                          to={`/master/survey/view/${item.id}`}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                        <Button
                          as={Link}
                          variant="warning"
                          to={`/master/survey/edit/${item.id}`}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </Button>
                        <Button
                          variant="danger"
                          onClick={() => onClickDelete(item.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </ButtonGroup>
                    </th>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan="6" style={{ textAlign: "center" }}>
                    Tidak ada data!
                  </th>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <Form.Group>
                <Form.Select
                  placeholder="Row"
                  value={row}
                  onChange={(e) => setRow(e.target.value)}
                >
                  <option defaultValue="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </Form.Group>

              <PaginationComponent
                meta={data?.meta}
                handlePagination={(item) => handlePagination(item)}
              />
            </div>
          </div>
        </Card.Footer>
      </Card>
    </AdminLayout>
  );
};

export default DataList;
